export function defaultFormatKilometrageNumbers(value: number | string | null | undefined, fallback = 'Sem informação') {
  if (value === null || value === undefined) {
    return fallback;
  }

  const numericValue = Number(value);
  if (Number.isNaN(numericValue)) {
    return fallback;
  }

  const fixedNumberArray = numericValue.toFixed(2).split('');
  const lastNumber = fixedNumberArray.pop();

  if (lastNumber !== undefined && Number(lastNumber) > 5) {
    const previusNumber = fixedNumberArray.pop() as string;
    fixedNumberArray.push(String(Number(previusNumber) + 1));
  }
  fixedNumberArray.push(lastNumber == '5' ? '5' : '0');

  return Number(fixedNumberArray.join('')).toLocaleString('pt-br', {
    style: 'unit',
    unit: 'kilometer',
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
}

